import React, {useState} from "react";
import styled from "styled-components";
import spriteImage from '../../assets/images/sprite.png';
import bus01 from '../../assets/images/bus_01.jpg';
import bus02 from '../../assets/images/bus_02.jpg';
import mBus01 from '../../assets/images/m-bus1.jpg';
import mBus02 from '../../assets/images/m-bus2.jpg';
import tour01 from '../../assets/images/tour_01.jpg';
import tour02 from '../../assets/images/tour_02.jpg';
import tour03 from '../../assets/images/tour_03.jpg';
import mTour01 from '../../assets/images/m-tour1.jpg';
import mTour02 from '../../assets/images/m-tour2.jpg';
import mTour03 from '../../assets/images/m-tour3.jpg';
import PageHeader from "../../components/organisms/PageHeader";
import Table from "../../components/molecules/Table";
import SubTitle from "../../components/atoms/SubTitle";
import Btn from "../../components/atoms/Btn";
import Modal from "../../components/organisms/Modal";
import {useNavigate} from "react-router-dom";
import ShuttleBusModal from "../../components/templates/ShuttleBusModal";
import {device} from "../../assets/styles/media.js";
import {useMediaQuery} from "react-responsive";
import notiList from "../../data/menu1/notiList.json";
import SimbolTarget from "../../components/atoms/SimbolTarget";
import NoticeBox from "../../components/molecules/NoticeBox";
import InfoCard from "../../components/atoms/InfoCard";
import Bullet from "../../components/atoms/Bullet";

const Contents = styled.div`
    margin-top: 60px;
    margin-bottom: 140px;
    
    ${device.mobile}{
        margin-top: 30px;
        margin-bottom: 50px;
    }
`;
const Section = styled.section`
    margin-bottom: 29px;
`;
const NotifyList = styled.ul`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap: 10px;

    ${device.pc} {
        gap: 20px;
    }
    ${device.tablet} {
        grid-template-columns: 1fr 1fr;
    }
    ${device.mobile} {
        grid-template-columns: 1fr;
        place-items: flex-start;
    }
`;
const EtcContents = styled.div`
    padding-top: 20px;
    ${device.tablet} {
        padding-top: 15px;
    }
    ${device.mobile}{
        margin-bottom: 20px;
        padding-top: 0;
    }
`;
const ImageWrap = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;

    img:first-child {
        width: 65%;
    }
    img:last-child {
        width: 32%;
    }
    ${device.tablet} {
        display: block;
        text-align: center;
        img:first-child {
            max-width: 100vw;
            width: 100%;
            height: auto;
        }
        img:last-child {
            padding-top: 40px;
            width: 100%;
            height: auto;
        }
    }

    ${device.mobile} {
        flex-direction: column;
        img:first-child {
            width: 100%;
            height: auto;
        }
        img:last-child {
            padding-top: 20px;
            width: 100%;
            height: auto;
        }
    }
`;
const TourImageWrap = styled.div`
    display: flex;
    justify-content: space-between;
    img {
        width: 460px ;
        height: 470px;
    }
    
    ${device.tablet} {
        flex-direction: column;
        img {
            padding-bottom: 40px;
            width: 100% ;
            height: auto;
        }
        img:last-child {
            padding-bottom: 0;
        }
    }
    ${device.mobile} {
        flex-direction: column;
        img {
            width: 100%;
            height: auto;
            padding-bottom: 20px;
        }
        img:last-child {
            padding-bottom: 0;
        }
    }
  
`;
const BusImage = styled.img`
    max-width: 100%;
    vertical-align: middle;
`;
const Description = styled.div`
   padding: 20px;
`;
const Description2 = styled(Description)`
    padding: 27px 149px 27px 30px;
    box-sizing: initial;
    ${device.tablet} {
      padding: 20px;
    }
    ${device.mobile} {
        padding: 20px;
    }
   
`;


const UsageGuide = () => {
    const navigate = useNavigate();
    const [openModal, setOpenModal] = useState(false);
    const isTablet = useMediaQuery({maxWidth: 1023});
    const navList = [
        { name: "이용시간", link: "#" },
        { name: "유의사항", link: "#caution" },
        { name: "입장제한 반려견", link: "#restricted-dogs" },
        { name: "반려견 동반관람 TIP", link: "#dog-friendly-tip" },
        { name: "무료셔틀버스 운행", link: "#free-shuttle" },
        { name: "투어 및 단체예약", link: "#tour-group-reservation" }
    ];

    const limitList = [
        {
            item: '동물보호법 시행규칙 제1조 2항에 근거한 맹견품종',
            desc: '(도사견, 아메리칸 핏불 테리어, 아메리칸 스태퍼드셔 테리어, 스태퍼드셔 불 테리어, 로트와일러 및 그 잡종의 개)'
        },
        {
            item: '동물보호법 상 맹견으로 표기되지 않았으나 위압감을 주거나 공격성향이 강한 품종',
            desc: '(도고 아르헨티노, 케인코르소, 오브차카, 티베탄 마스티프,울프독 등)'
        },
        {
            item: '기타 다른 반려견이나 사람에게 피해를 줄 수 있는 개',
        },
        {
            item: '반려동물 등록이 되어 있지 않은 개',
        },
    ];
    const tipList = [
        {
            item: ["자동차 여행으로 지친 강아지에게","해주세요."],
            bold: ' 충분한 물을 제공'
        },
        {
            item: ["강아지가","할 수 있도록 시간을 갖고 기다려 주세요."],
            bold: ' 낯선 환경에 적응'
        },
        {
            item: ["강아지에게 주변 냄새를 충분히 맡게 한 후","하게 해주세요."],
            bold: ' 강아지 화장실을 이용'
        },
        {
            item: ["박물관동에 ", " 강아지 동반 입장 시, 반드시 ", "산책줄과 매너벨트를 착용", "시켜주세요.\n(매표소서 1두당 매너벨트 1개 무료 제공, 추가 필요시에는 마켓에서 구입 가능)"],
            isSpecial: true // 새로운 케이스라는 표시
        },
        {
            item: ["에너지가 넘치는 강아지 동반 시, ","하세요."],
            bold: '운동장을 먼저 방문'
        },
        {
            item: ["강아지숲을 좋아하는 강아지와 함께 지내고 있다면 ","할 수 있어요."],
            bold: '연간회원권 구매 시, 보다 합리적인 가격으로 강아지숲을 이용'
        }
    ];


    const headers = [{name:"입장일"}, {name:"휴관일"}];
    const data = [
        ["수요일 - 일요일\n10:00 - 18:00", "월요일, 화요일 휴장\n(단, 공휴일 및 대체휴무일인 경우 정상운영)"],
        ["폐장 1시간 전 발권 마감", "설, 추석 당일 휴장"]
    ];
    return (
        <>
                    <PageHeader
                        bTitle="이용안내"
                        detail="관람 안내"
                        desc="강아지숲 관람을 안내해 드립니다."
                        list={navList}
                        link={true}
                     />

                    <Contents >
                        {/*이용시간*/}
                        <Section  >
                            <Table subTitle="이용시간" headers={headers} data={data} highlightRows={[1]} />
                        </Section>
                        <SimbolTarget id="caution"/>

                        {/*유의사항*/}
                        <Section>
                            <SubTitle text={"유의사항"} />
                            <NotifyList>
                                {notiList.map((item, index) => (
                                    <InfoCard key={index} item={item} image={spriteImage}/>
                                ))}
                            </NotifyList>
                        </Section>
                        <SimbolTarget id="restricted-dogs"/>


                        {/*  입장제한 반려견*/}
                        <Section>
                            <SubTitle text={"입장제한 반려견"} />
                            <NoticeBox list={limitList}/>
                        </Section>
                        <SimbolTarget id="dog-friendly-tip"/>

                        {/* 반려견 동반관람 TIP*/}
                        <Section>
                            <SubTitle text={"반려견 동반관람 TIP"} />
                            <NoticeBox list={tipList} bgColor={"#fbfbfb"}/>
                        </Section>
                        <SimbolTarget id="free-shuttle"/>

                     {/*  무료셔틀버스 운행*/}
                        <Section >
                            <SubTitle text={"무료셔틀버스 운행"} />
                            <EtcContents>
                                <ImageWrap>
                                    <BusImage src={isTablet ? mBus01 : bus01} alt="셔틀버스 사진1" />
                                    <BusImage src={isTablet ? mBus02 : bus02} alt="셔틀버스 사진2" />
                                </ImageWrap>
                                <Description>
                                    <Bullet>
                                        강아지숲은 방문객들의 편의를 위해 테마파크 내 무료 셔틀버스 서비스를 제공하고 있습니다.
                                    </Bullet>
                                </Description>
                            </EtcContents>
                            <Btn
                                text={"자세히보기"}
                                onClick={() => setOpenModal(true)}
                                mt={30}
                            />
                        </Section>
                        <SimbolTarget id="tour-group-reservation"/>

                        {/*  투어 및 단체 예약 */}
                        <Section >
                            <SubTitle text={"투어 및 단체 예약"} />
                            <EtcContents>
                                <TourImageWrap>
                                    <BusImage src={isTablet ? mTour01 : tour01} alt="투어및단체예약" />
                                    <BusImage src={isTablet ? mTour02 :tour02} alt="투어및단체예약" />
                                    <BusImage src={isTablet ? mTour03 :tour03} alt="투어및단체예약" />
                                </TourImageWrap>
                                <Description2>
                                    <Bullet>
                                        강아지숲은 단체예약 서비스를 제공하고 있습니다.
                                    </Bullet>
                                </Description2>
                            </EtcContents>
                            <Btn
                                text={"자세히보기"}
                                onClick={()=>navigate("/guide/group")}
                                mt={30}
                            />
                        </Section>
                    </Contents>
            {openModal &&
                <Modal
                   title={"무료 셔틀 운행"}
                   open={openModal}
                   setOpenModal={setOpenModal}
                   content={<ShuttleBusModal/>}
                />
            }
        </>
    );
};

export default UsageGuide;
